export default __webpack_public_path__ + "static/media/CGV_Gonak.5f2c8851.pdf";